import { Text, Badge } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import ValidationBadge from './ValidationBadge';

interface MVRLicenseStatusCardProps {
  data?: { drivers: { name: string; status: string; isValid: boolean }[] };
}

const MVRLicenseStatusCard = ({ data }: MVRLicenseStatusCardProps) => {
  const formatDriverName = (name: string) => {
    if (!name || name.trim() === '') {
      return (
        <Text color="gray.400" fontStyle="italic" fontSize="sm">
          Not provided
        </Text>
      );
    }
    return name;
  };

  const formatStatus = (status: string) => {
    return (
      <Badge colorScheme="blue" variant="outline" fontSize="xs">
        {status || 'Unknown'}
      </Badge>
    );
  };

  const headers = ['Driver', 'Status', 'Outcome'];

  const rows = data?.drivers.map((row: any) => [
    formatDriverName(row.name),
    formatStatus(row.status),
    row.isValid ? (
      <ValidationBadge status="pass" />
    ) : (
      <ValidationBadge status="caution" />
    ),
  ]);

  return (
    <DataTableCard
      description="Review MVR license information and status for all drivers."
      headers={headers}
      rows={rows}
    />
  );
};

export default MVRLicenseStatusCard;
